import script from "./WDentalCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./WDentalCard.vue?vue&type=script&lang=ts&setup=true"

import "./WDentalCard.vue?vue&type=style&index=0&id=6b14f9f1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b14f9f1"]])

export default __exports__